module.exports = __webpack_public_path__ + "static/media/paraguai.6766bc4f.webp";